<template>
    <div v-if="publisher || !isEdit">
        <LaBaseForm
            :form-data="
                isEdit
                    ? {
                          id: publisher.id,
                          name: name,
                          status: publisherStatus,
                          currency: publisherCurrency,
                          performax_id: performaxId,
                          zoho_id: zohoId,
                          is_yield: isYield,
                          is_performax_dashboard: dashboardType === 'Performax' ? 1 : 0,
                      }
                    : {
                          name: name,
                          status: publisherStatus,
                          performax_id: performaxId,
                          zoho_id: zohoId,
                          is_yield: isYield,
                          is_performax_dashboard: dashboardType === 'Performax' ? 1 : 0,
                      }
            "
            :vuex-action-mutation="formAction"
            :button="isEdit ? 'Save' : 'Add publisher'"
            id="publisher"
            buttonPortalTo="modalFooter"
        >
            <LaBaseInput
                data-test="publisher-name"
                v-model="name"
                name="name"
                label="Name"
                id="name"
                :rules="rules.name"
                :error="errors.name"
            />

            <InputContainer label="Status" name="status">
                <div class="base-input-container">
                    <LaBaseSelect
                        data-test="publisher-status"
                        :items="statusArr"
                        v-model="publisherStatus"
                        :stretch="true"
                        :searchable="false"
                    >
                    </LaBaseSelect>
                </div>
            </InputContainer>

            <InputContainer label="Currency" name="currency">
                <div class="base-input-container">
                    <LaBaseSelect
                        data-test="publisher-currency"
                        :items="currencyArr"
                        v-model="publisherCurrency"
                        :stretch="true"
                        :searchable="false"
                    >
                    </LaBaseSelect>
                </div>
            </InputContainer>

            <LaBaseInput
                data-test="publisher-performax-id"
                v-model="performaxId"
                name="performaxId"
                label="Performax ID"
                id="performax-id"
                type="number"
            />

            <LaBaseInput
                data-test="publisher-zoho-id"
                v-model="zohoId"
                name="zohoId"
                label="Zoho ID"
                id="zoho-id"
                type="text"
            />

            <LaBaseCheckbox v-model="isYield" name="Is yield" data-test="is-yield"> Is Yield </LaBaseCheckbox>

            <InputContainer v-if="userRights['super_admin']" label="Dashboard type" name="dashboard_type">
                <div class="base-input-container">
                    <LaBaseSelect
                        data-test="publisher-dashboard-type"
                        :items="dashboardTypeArr"
                        v-model="dashboardType"
                        :stretch="true"
                        :searchable="false"
                    >
                    </LaBaseSelect>
                </div>
            </InputContainer>
        </LaBaseForm>
    </div>
</template>

<script>
import LaBaseForm from "@/components/BaseForm";
import LaBaseInput from "@/components/inputs/BaseInput";
import LaBaseSelect from "@/components/inputs/BaseSelect";
import LaBaseCheckbox from "@/components/inputs/BaseCheckbox.vue";
import InputContainer from "@/components/inputs/InputContainer";
import { computed, ref } from "vue";
import { isRequired } from "@/helpers/rules";
import store from "@/store/store";
import { actionTypes, getterTypes } from "@/store/Publisher/types";
import { getterTypes as dialogGetterTypes } from "@/store/Dialog/types";
import { getterTypes as userGetterTypes } from "@/store/LoggedUser/types";
import { list_of_currencies, default_currency } from "@/helpers/data";

export default {
    name: "PublisherForm",
    components: {
        LaBaseForm,
        InputContainer,
        LaBaseInput,
        LaBaseSelect,
        LaBaseCheckbox,
    },
    setup() {
        let isEdit = ref(false);
        let name = ref("");
        let publisherStatus = ref(default_currency);
        let publisherCurrency = ref("");
        let performaxId = ref("");
        let zohoId = ref("");
        let isYield = ref(false);
        let dashboardType = ref("LTBA");
        let formAction = actionTypes.createPublisher;
        const publisher = computed(() => store.getters[dialogGetterTypes.getDialog].item);
        const userRights = computed(() => store.getters[userGetterTypes.getUserRights]);

        publisherStatus.value = "Active";
        publisherCurrency.value = default_currency;

        if (publisher.value) {
            isEdit = true;
            name.value = publisher.value.name;
            publisherStatus.value = publisher.value.status;
            if (publisher.value.currency) {
                publisherCurrency.value = publisher.value.currency;
            }
            performaxId.value = publisher.value.performax_id;
            zohoId.value = publisher.value.zoho_id;
            isYield.value = publisher.value.is_yield;
            dashboardType.value = publisher.value.is_performax_dashboard ? "Performax" : "LTBA";
            formAction = actionTypes.editPublisher;
        }
        const rules = {
            name: [isRequired()],
        };

        const errors = computed(() => store.getters[getterTypes.getCreatePublisherErrors] || {});
        const statusArr = ["Active", "Inactive", "New", "Light Demo", "Onboarding"];
        const currencyArr = list_of_currencies;
        const dashboardTypeArr = ["LTBA", "Performax"];

        return {
            isEdit,
            formAction,
            rules,
            errors,
            name,
            performaxId,
            zohoId,
            publisherStatus,
            publisherCurrency,
            statusArr,
            currencyArr,
            dashboardTypeArr,
            publisher,
            isYield,
            dashboardType,
            userRights,
        };
    },
};
</script>

<style scoped></style>
